// components/season/UserTeams.js
import AddTeamModal from '../teams/AddTeamModal';
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Dropdown, Row, Col } from "react-bootstrap";
import Icon from '@mdi/react';
import { mdiAccountMultiplePlusOutline } from '@mdi/js';
import axios from 'axios';
import JoinTeamModal from '../profile/JoinTeamModal';

function UserTeams() {
  const { userId } = useParams();
  const [teams, setTeams] = useState([]);
  const [playerName, setPlayerName] = useState('');
  const [activeLeague, setActiveLeague] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [showJoinTeamModal, setShowJoinTeamModal] = useState(false);
  const handleShow = () => setModalVisible(true);
  const handleClose = () => setModalVisible(false);

  useEffect(() => {
    // Fetch player details
    axios
      .get(`/api/users/my-details/`, {
        withCredentials: true,
      })
      .then((response) => {
        const { first_name, last_name } = response.data;
        setPlayerName(`${first_name} ${last_name}`); // Set player's full name
      })
      .catch((error) => {
        console.error('Error fetching player details:', error);
        alert('Unable to fetch player details.');
      });

    // Fetch teams for the User
    axios
      .get(`/api/teams/user-teams/`, {
        withCredentials: true,
      })
      .then((response) => setTeams(response.data))
      .catch((error) => {
        console.error('Error fetching teams:', error);
        alert('Unable to fetch teams.');
      });

    axios.get('/api/leagues/active-leagues/', {
      withCredentials: true,
    })
      .then(response => {
        if (!activeLeague && response.data.length > 0) {
          const defaultLeague = response.data[0];
          setActiveLeague(defaultLeague);
        }
      })
      .catch(error => {
        console.error('Error fetching leagues:', error);
      });

  }, [userId, setActiveLeague, activeLeague]);

  // Function to handle a newly added team
  const handleTeamAdded = (newTeam) => {
    setTeams((prevTeams) => [...prevTeams, newTeam]);
  };

  const handleJoinTeamSuccess = () => {
    // Refresh the teams list
    if (activeLeague) {
      axios.get(`/api/teams/league/${activeLeague.id}/teams/`, {
        withCredentials: true,
      })
        .then(response => {
          setTeams(response.data);
        })
        .catch(error => {
          console.error('Error fetching teams:', error);
        });
    }
  };

  return (
    <div className="container p-0">
      <div className="card">
        {/* Header Section */}
        <div className="card-header border-0 pb-0">
          <Row>
            <Col xs={10}>
              <h2 className="h4 card-title">Teams for {playerName}</h2>
            </Col>
            <Col xs={2} className="text-end">
              {/* Add Team Button triggers the modal */}
              <Dropdown className="ms-auto">
                <Dropdown.Toggle variant="text-secondary" id="dropdown-basic" className="custom-dropdown-toggle">
                  <i className="bi bi-three-dots"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#" onClick={handleShow}>
                    <i className="fa-solid fa-plus ps-1 pe-2"></i> Create Team
                  </Dropdown.Item>
                  <Dropdown.Item href="#" onClick={() => setShowJoinTeamModal(true)}>
                    <Icon path={mdiAccountMultiplePlusOutline} size={1} /> Join a Team
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </div>

        {/* Body Section */}
        <div className="card-body">
          <div className="row g-4">
            {/* Map through the list of teams and render each one */}
            {teams.map((team) => (
              <div key={team.id} className="col-sm-6 col-xl-4">
                {/* Make the entire card clickable */}
                <Link to={`/teams/${team.id}`} className="text-decoration-none">
                  <div className="card h-100">
                    <div className="position-relative">
                      <img
                        className="img-fluid rounded-top"
                        src={team.logo || `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`}
                        alt={`${team.name} logo`}
                        style={{
                          width: '200px',
                          height: '200px',
                          objectFit: 'cover',
                          margin: 'auto',
                          display: 'block',
                        }}
                      />
                    </div>
                    <div className="card-body position-relative pt-0">
                      <h6 className="mt-3 text-dark">{team.name}</h6>
                      <p className="mb-0 small text-muted">
                        <i className="bi bi-trophy pe-1"></i> Wins: {team.wins}
                      </p>
                      <p className="small text-muted">
                        <i className="bi bi-trophy-fill pe-1"></i> Losses: {team.losses}
                      </p>
                      <p className="small text-muted">
                        <i className="bi bi-trophy-fill pe-1"></i> Draws: {team.draws}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add Team Modal */}
      <AddTeamModal
        show={modalVisible}
        handleClose={handleClose}
        onTeamAdded={handleTeamAdded}
      />

      {/* Join Team Modal */}
      <JoinTeamModal
        isOpen={showJoinTeamModal}
        onClose={(success) => {
          setShowJoinTeamModal(false);
          if (success) {
            handleJoinTeamSuccess();
          }
        }}
        leagueId={activeLeague?.id}
      />
    </div>
  );
}

export default UserTeams;
